module.exports = __webpack_public_path__ + "img/HQ-PA050W2T2RL.8f574a08.jpg";